import React, {Fragment} from "react";
import {
	TermsCheckBoxContainer,
	ITermsModalProps,
	TermsButton,
	TermsText,
	TermsTitle,
} from "components/CheckTerms/common";
import {Trans, useTranslation} from "react-i18next";
import {useSelector} from "react-redux";
import {getUserStore, isBettingCountySelector} from "modules/selectors";

export const TermsUSABetting: React.FC<ITermsModalProps> = ({
	onPlay,
	trackActionRules,
	handlerChange,
}) => {
	const {t} = useTranslation();
	const isBettingCountry = useSelector(isBettingCountySelector);
	const {countryCode} = useSelector(getUserStore);
	const isUSBetting = countryCode === "US";

	if (!isBettingCountry || !isUSBetting) {
		return null;
	}
	return (
		<React.Fragment>
			<TermsTitle>{t("terms_modal.title_usa")}</TermsTitle>
			<TermsText>
				<Fragment>
					<Trans i18nKey="terms_modal.content.description">
						By clicking "Play Now", I acknowledge that I have read, understand, and
						agree to be bound by the{" "}
						<a
							onClick={trackActionRules}
							target="_blank"
							rel="noreferrer"
							href="https://www.mlb.com/apps/beat-the-streak/official-rules"
						>
							Official Rules
						</a>
						{", "}
						<a
							onClick={trackActionRules}
							target="_blank"
							rel="noreferrer"
							href="https://www.mlb.com/official-information/terms-of-use"
						>
							Terms of Use
						</a>
						, and{" "}
						<a
							onClick={trackActionRules}
							target="_blank"
							rel="noreferrer"
							href="https://www.mlb.com/official-information/privacy-policy"
						>
							MLB Privacy Policies
						</a>
					</Trans>
					<TermsCheckBoxContainer>
						<input type="checkbox" onChange={handlerChange} />
						<Trans i18nKey="terms_modal.acknowledge">
							I acknowledge that I have read, understand, and agree to be bound by the{" "}
							<a
								target="_blank"
								rel="noreferrer"
								href="https://www.betmgminc.com/privacy-policy/"
							>
								BetMGM Privacy Policy
							</a>{" "}
							and that my registration and game information will be shared with BetMGM
							and its subsidiaries and affiliates.
						</Trans>
					</TermsCheckBoxContainer>
				</Fragment>
			</TermsText>
			<TermsButton type={"button"} onClick={onPlay}>
				{t("terms_modal.button_success")}
			</TermsButton>
			<div className="abbrev-rules">
				<Trans i18nKey="terms_modal.no_purchase">
					NO PURCHASE NECESSARY. Open to legal residents of the U.S. and Canada (excluding
					Quebec), 21+. Enter by the earlier of the conclusion of the final game of the
					2023 MLB regular season or confirmation that Grand Prize has been won. Void
					where prohibited. Restrictions apply; click for{" "}
					<a
						target="_blank"
						rel="noreferrer"
						href="https://www.mlb.com/apps/beat-the-streak/official-rules"
					>
						Official Rules
					</a>
					. Sponsor: MLB Advanced Media, L.P.
				</Trans>
			</div>
		</React.Fragment>
	);
};
